<template>
<body>
  <div v-if="!editingCard" class="modalContainer active loginModal formsModal">

    <div class="actualModal">
      <a href="/#/user/account" class="closeModal"><i class="fal fa-times"></i></a>
      <div class="modalBodyOfItem" style="flex-direction: column; height: auto;">
        <form @submit.prevent="changeCard" class="itemBodyLeftModal">
          <h4>New Profile</h4>
          <div class="dualInputContainerForm">

            <div class="inputsContainer">
              <h2>Profile Details</h2>
              <div class="individualInput">
                <h5>Profile Name</h5>
                <input v-model="profileForm.profileName" type="text" name="profileName" placeholder="Main Profile" />
              </div>
              <div class="individualInput">
                <h5>Full Name</h5>
                <input v-model="fullName" type="text" name="fullname" placeholder="John Doe" />
              </div>
              <div class="individualInput">
                <h5>Phone Number</h5>
                <input ref="phone" maxlength="16" v-model="profileForm.phone" type="number" name="phone" placeholder="8185555555" />
              </div>
              <div class="individualInput">
                <h5>Email</h5>
                <input v-model="profileForm.email" type="text" name="email" placeholder="you@example.com" />
              </div>
              <div class="individualInput">
                <h5>Country</h5>
                <select style="color: black" v-model="profileForm.shipping.country" name="state">
                  <option v-for="(country,key) in countries" :value="key">{{country}}</option>
                </select>
              </div>
            </div>

            <div class="inputsContainer">
              <h2>Payment/Billing</h2>
              <div class="individualInput">
                <h5>Address</h5>
                <input ref="autocomplete" v-model="profileForm.shipping.address1" type="text" name="address1" placeholder="123 Cherry Ave" />
              </div>
              <div class="individualInput">
                <h5>City</h5>
                <input v-model="profileForm.shipping.city" type="text" name="city" placeholder="New York" />
              </div>
              <div v-if="profileForm.shipping.country == 'US'" class="individualInput">
                <h5>State</h5>
                <select style="color: black" v-model="profileForm.shipping.state" name="state">
                  <option v-for="(state,key) in states" :value="key">{{state}}</option>
                </select>
              </div>
              <div v-if="profileForm.shipping.country != 'US'" class="individualInput">
                <h5>State</h5>
                <input v-model="profileForm.shipping.state" placeholder="State">
              </div>
              <div class="individualInput">
                <h5>Zip Code</h5>
                <input maxlength="10" v-model="profileForm.shipping.zip" type="text" name="zip" placeholder="10001" />
              </div>
              <div class="individualInput">
                <h5>Credit Card</h5>
                <div class="ccSaved">
                  <a @click="changeCard" class="addCC">Add Credit Card+</a>
                </div>
              </div>
            </div>

          </div>

          <div class="quickCheckout" style="padding-bottom: 50px;">
            <div style="margin-bottom: 5px;" v-if="haserrors" class="error">Please double check your information.</div>
            <button type="submit">Add Profile</button>
          </div>

        </form>
      </div>
    </div>
  </div>
  <!-- credit card modal -->

  <div v-if="editingCard" class="modalContainer active loginModal formsModal">
    <div class="actualModal">
      <a @click="changeCard" href="#" class="closeModal"><i class="fal fa-times"></i></a>
      <div class="modalBodyOfItem">
        <div class="itemBodyLeftModal">
          <h4>Credit Card Info</h4>
          <div class="inputsContainer">
            <div class="individualInput">
              <h5>Full Name</h5>
              <input v-model="profileForm.card.name" type="text" name="" id="" placeholder="John Doe" />
            </div>
            <div class="individualInput">
              <h5>Credit Card Number</h5>
              <input maxlength="16" v-model="profileForm.card.number" type="text" name="" id="" placeholder="Enter Card Number" />
            </div>
            <div class="dualInputContainer">
              <div class="individualInput">
                <h5>Expiration Date</h5>
                <input maxlength="5" v-model="expdate" type="text" name="" id="" placeholder="00/00" />
              </div>
              <div class="individualInput">
                <h5>Security Code</h5>
                <input maxlength="4" v-model="profileForm.card.code" type="text" name="" id="" placeholder="000" />
              </div>
            </div>
          </div>
          <div class="quickCheckout">
            <div style="margin-bottom: 5px;" v-if="haserrors" class="error">Please double check your information.</div>
            <a @click="saveProfile" href="#">Save Profile</a>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- ./credit card modal -->
</body>
</template>
<script>
const ADDRESS_COMPONENTS = {
  subpremise: 'short_name',
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'short_name',
  administrative_area_level_2: 'long_name',
  country: 'long_name',
  postal_code: 'short_name'
};
const CITIES_TYPE = ['locality', 'administrative_area_level_3'];
const REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country',
  'administrative_area_level_1', 'administrative_area_level_2'
];
import { setupService } from '@/services/setup'
import {
  aesToAco,
  acoToAES,
  validateObject
} from '@/helpers/acoData'
import validator from 'validator'
import creditCardType from 'credit-card-type'
import states from '@/helpers/states'
import countries from '@/helpers/countries'
import {
  profileService
} from '@/services/profiles'
export default {
  computed: {
    cardType() {
      if (!this.profileForm || !this.profileForm.card) return
      let {
        number
      } = this.profileForm.card
      if (!number) return this.profileForm.card.cardType
      let numString = number.toString()
      let cards = creditCardType(numString)
      if (cards && cards[0].type) return cards[0].type
      return cards
    },
    last4() {
      let {
        number
      } = this.profileForm.card
      if (!number) return
      // console.log(number,this.profileForm.card)
      return number.toString().slice(-4)
      // return this.profileForm.card.number.slice(-4)
    },
  },
  data() {
    return {
      countries,
      countryString: null,
      haserrors: false,
      expdate: null,
      editingCard: false,
      states,
      profiles: [],
      fullName: null,
      profileForm: {
        email: null,
        phone: null,
        profileName: null,
        shipping: {
          address1: null,
          address2: null,
          firstName: null,
          lastName: null,
          city: null,
          zip: null,
          state: null,
          country: 'US',
        },
        card: {
          name: null,
          number: null,
          code: null,
          month: null,
          year: null,
          cardType: null
          // zip: null,
        }
      }
    }
  },
  watch: {
    countryString(n, o) {
      let code = this.getCountryCodeFromString(n)
      console.log(n, code)
      this.profileForm.shipping.country = code
    },
    'profileForm.phone'(n, o) {
      // console.log(n,typeof n)
      let ns = n.toString()
      if (ns.length > 15) {
        this.profileForm.phone = ns.slice(0, 15)
      }
    }
  },
  mounted() {
    this.autocomplete = new google.maps.places.Autocomplete(
      (this.$refs.autocomplete), {
        types: ['geocode'],
      }
    );
    this.autocomplete.addListener('place_changed', (x) => {
      let place = this.autocomplete.getPlace();
      console.log(place)
      let ac = place.address_components;
      let lat = place.geometry.location.lat();
      let lon = place.geometry.location.lng();
      let formatted = this.formatResult(place)
      console.log(`address:`, formatted)
      // console.log(ac[0], 67, ac, place)
      // let city = ac[0]["short_name"];
      this.profileForm.shipping.city = formatted.locality
      this.profileForm.shipping.address1 = formatted.street_number + ' ' + formatted.route
      this.profileForm.shipping.state = formatted.administrative_area_level_1
      this.profileForm.shipping.zip = formatted.postal_code
      this.countryString = formatted.country
      console.log(`The user picked coordinates ${lat}, ${lon}`);
    });
  },
  methods: {
    getCountryCodeFromString(str) {
      for (let k in this.countries) {
        if (this.countries[k] == str) {
          return k
        }
      }
    },
    formatResult(place) {
      let returnData = {};
      for (let i = 0; i < place.address_components.length; i++) {
        let addressType = place.address_components[i].types[0];
        if (ADDRESS_COMPONENTS[addressType]) {
          let val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
          returnData[addressType] = val;
        }
      }
      returnData['latitude'] = place.geometry.location.lat();
      returnData['longitude'] = place.geometry.location.lng();
      return returnData
    },
    async createToken() {
      let { card } = this.profileForm
      let cardData = {
        card: {
          name: this.profileForm.card.name,
          number: card.number,
          exp_month: card.month,
          exp_year: card.year,
          cvc: card.code,
          address_zip: this.profileForm.shipping.zip
        },
      }
      // console.log(`creating stripe token with data`, cardData)
      let token = await setupService.getStripeToken(cardData)
      // console.log(`got token`, token)
      return token
    },
    changeCard() {
      console.log(`changing card`)
      if (!this.validateForm()) return this.haserrors = true
      this.editingCard = !this.editingCard
    },
    validateForm() {
      let { profileForm } = this
      if (!profileForm.profileName || !profileForm.phone || !profileForm.email) {
        console.log('name or phone empty')
        return false
      }
      let validPhone = validator.isMobilePhone(profileForm.phone)
      let isEmail = validator.isEmail(profileForm.email)
      if (!validPhone || !isEmail) {
        console.log('phone or email')
        return false
      }
      let fname = this.fullName.split(' ')[0]
      let lname = this.fullName.split(' ')[1]
      if (!fname || !lname) {
        return false
      }
      this.profileForm.shipping.firstName = fname
      this.profileForm.shipping.lastName = lname

      let { shipping } = profileForm
      let { address1, city, zip, state, firstName, lastName } = shipping
      if (!address1 || !city || !zip || !state || !firstName || !lastName) return false
      let validCC
      if (profileForm.card.number) validCC = validator.isCreditCard(profileForm.card.number)
      if (profileForm.card.number && !validCC) return false
      return true
    },
    async saveProfile() {
      console.log(`saving profile...`)
      if (this.cardType) this.profileForm.card.cardType = this.cardType
      if (!this.expdate) {
        this.haserrors = true
        return console.log('fuck fuck fuck')
      }
      let split = this.expdate.split('/')
      let month = split[0]
      let year = split[1]
      if (month) this.profileForm.card.month = month
      if (year) this.profileForm.card.year = year
      if (this.cardType) this.profileForm.card.cardType = this.cardType
      let firstName = this.fullName.split(' ')[0]
      let lastName = this.fullName.split(' ')[1]
      if (!firstName || !lastName) {
        return this.haserrors = true
      }
      this.profileForm.shipping.firstName = firstName
      this.profileForm.shipping.lastName = lastName

      this.profileForm.billing = this.profileForm.shipping
      let {
        profileForm
      } = this
      let alid = validateObject(profileForm)
      let validForm = this.validateForm()
      if (!alid || !validForm) {
        this.haserrors = true
        return console.error('form not valid')

      }
      console.log(`creating token with card for verification`)
      let token = await this.createToken()
      if (!token) {
        this.haserrors = true
        return
      }
      console.log(`saving profile ${profileForm.profileName}`, profileForm)
      if (!alid) return console.log('invalid object')
      let encryptedProfile = acoToAES(profileForm)
      profileService.addProfile(encryptedProfile)
        .then((resp) => {
          console.log(`save profile resp ->`, resp)
          this.$store.dispatch('profiles/getProfiles')
          this.$router.push('/user/profiles')
          // if(!resp.success) return con
        })
    }
  }
}
</script>
